import { forwardRef, useRef, useState } from "react";
import { AddressCard } from "./Address.js";
import { CopyButton } from "./Buttons.js";
import { useClickOutside } from "../util.js";
import { Spinner } from "./Spinner.js";

export function Tuple({children, position}) {
  return <div className="flex flex-col w-full gap-2 mb-5">
    <div className="text-left text-gray-700 whitespace-nowrap">{children[0]}</div>
    <div className="flex justify-between items-center">
      <div className="text-left flex-1 font-semibold">{children[1]}</div>
      <div className="text-green-600 text-sm text-right max-w-fit min-w-[5rem] verified" style={{'--delay': `0.${position}s`}}>Verified</div>
    </div>
  </div>;
}

export function WithCopyOnHover({text, title="Copy", children, className}) {
  return <div className={["flex flex-row items-center group/coh", className].join(" ")}>
    {children}
    <CopyButton
      value={text}
      title={title}
      className="
        hidden group-hover/coh:block
        h-4 aspect-square hover:scale-110"
        />
  </div>
}

export function Hash({h,n=7, ...props}) {
  let editState = useState(false)
  const Menu = forwardRef(function(props, ref) {

    let { state: [isMenuOpen, setIsMenuOpen], className,...rest } = props
    function copyHash(e) {
      e.preventDefault()
      setIsMenuOpen(false);
      navigator.clipboard.writeText(h);
    }

    if (!isMenuOpen) return <></>
    return <ul ref={ref} className={[
      "absolute left-0 block border border-menu-border rounded bg-menu-bg px-1 py-1 w-fit font-normal", className].join(" ")} {...rest}>
      <li onClick={copyHash} className="block cursor-pointer rounded hover:bg-menu-hover px-1 text-left text-nowrap">Copy hash</li>
    </ul>
  })

  if (!h) return <></>;

  return <WithContextMenu CtxMenu={Menu}>
    <AddressCard h={h} state={editState}/>
  </WithContextMenu>
}

export function WithContextMenu(props) {
  let menuState = useState(false);
  let [ _, setIsMenuOpen ] = menuState;

  function showMenu(e) {
    e.preventDefault()
    setIsMenuOpen((state) => !state)
  }

  function hideMenu(e) {
    e.preventDefault()
    setIsMenuOpen(false)
  }
  let menuRef = useRef(null)
  useClickOutside(hideMenu, menuRef);

  let { CtxMenu, className, children,...rest } = props;

  return <div className={["relative inline-block", className].join(" ")} onContextMenu={showMenu} {...rest} >
    {children}
    <CtxMenu className="z-50" ref={menuRef} state={menuState} />
  </div>
}

export function HashDisplay(props) {
  // TODO: make a new namespace: Components/Hash
  let { h, n=7, fontSize, ...rest } = props
  if (!h) return <></>
  let hashText = h.slice(0,n)
  return <div title={h}
    className="pr-0.5 text-left truncate w-fit font-mono" style={{ fontSize }}>
    {hashText}
  </div>;
}

export function WithFallback({fallback, pred, children}) {
  let displayFallback = pred;
  if (pred instanceof Function) {
    displayFallback = pred();
  }
  if (displayFallback) {
    return fallback;
  } else {
    return <>{children}</>
  }
}
